import React, { useContext } from "react";
import RemoveDialog from "../../Components/RemoveDialog";
import BoardsContext from "../boardsContext";
import useSaveLocalMoodboard from "../useSaveLocalMoodboard";
import useSaveSettings from "../../User/useSaveSettings";

export default function ClearDialog({ clearDialog, setClearDialog }) {
  const saveLocalBoard = useSaveLocalMoodboard();
  const { moodboardDispatch } = useContext(BoardsContext);
  const saveSettings = useSaveSettings();

  const handleRemove = () => {
    saveLocalBoard.mutate([]);
    moodboardDispatch({ type: "SET_MOODBOARDS", payload: [] });
    saveSettings.mutate({ moodBoardId: "" }); // disable edit
  };
  return (
    <RemoveDialog
      open={clearDialog.open}
      setOpen={setClearDialog}
      removeFunction={handleRemove}
      dialogTitle={"Remove graphs for client?"}
      dialogContentText={"These graphs will be removed for your client"}
      dialogActionCancel={"No, keep graphs"}
      dialogActionConfirm={"Yes, remove graphs"}
    />
  );
}
